// Rich info about each program (used in landing page "Learn more" modal)
export const PROGRAM_INFO = {
  "career-entrepreneurship": {
    tagline: "Become career-ready & startup-savvy",
    modules: [
      "Career Planning & Goal Setting",
      "Idea Validation & Business Model Canvas",
      "Building a Lean MVP",
      "Pitching & Storytelling",
      "Funding Basics & Bootstrapping",
      "Operations, Hiring & Scaling",
    ],
    skills: ["Business Planning", "Pitching", "Market Validation", "Resume & LinkedIn", "Leadership Basics"],
    careers: ["Founder / Co-founder", "Business Analyst", "Product Associate", "Sales Trainee", "Operations Executive"],
  },
  "technology-ai": {
    tagline: "Build a strong foundation in AI & emerging tech",
    modules: [
      "Python Programming Essentials",
      "Data Structures & Algorithms (intro)",
      "Machine Learning Fundamentals",
      "Generative AI & LLM Basics",
      "Working with APIs & No-code AI Tools",
      "Mini Capstone: Build Your First AI App",
    ],
    skills: ["Python", "ML Concepts", "AI Tools (ChatGPT, Gemini)", "Data Handling", "Problem Solving"],
    careers: ["AI Associate", "Data Analyst (Jr.)", "Automation Specialist", "Tech Support Engineer"],
  },
  "digital-skills-marketing": {
    tagline: "Master modern digital marketing end-to-end",
    modules: [
      "SEO & SERP Strategy",
      "Social Media Marketing (Instagram, LinkedIn, YouTube)",
      "Google Ads & Meta Ads",
      "Email Marketing & Automation",
      "Analytics: GA4, Search Console, Pixel",
      "Capstone Campaign for a Real Brand",
    ],
    skills: ["SEO", "Paid Ads", "Content Strategy", "Analytics", "Copywriting"],
    careers: ["Digital Marketing Executive", "SEO Analyst", "Performance Marketer", "Social Media Manager"],
  },
  "web-development": {
    tagline: "Build & deploy real, modern websites",
    modules: [
      "HTML5, CSS3, Flex & Grid",
      "JavaScript Essentials & DOM",
      "React.js Components, Hooks & State",
      "Backend Basics: Node.js & Express",
      "Working with Databases (Firebase / MongoDB)",
      "Capstone: Portfolio + Live Project Deployment",
    ],
    skills: ["HTML/CSS/JS", "React", "Node.js", "Git & GitHub", "Deployment (Vercel/Netlify)"],
    careers: ["Frontend Developer", "Full-stack Trainee", "Web Designer", "UI Engineer (Jr.)"],
  },
  "digital-literacy": {
    tagline: "Be confident with computers, internet & everyday digital tools",
    modules: [
      "Computer & Internet Fundamentals",
      "MS Office: Word, Excel, PowerPoint",
      "Email & Calendar Etiquette",
      "Online Safety, Privacy & Cyber Hygiene",
      "Working with Google Workspace",
      "AI Assistants for Daily Productivity",
    ],
    skills: ["MS Office", "Email", "Google Workspace", "Cyber Safety", "AI Productivity"],
    careers: ["Office Executive", "Data Entry Operator", "Admin Assistant", "Front Desk Executive"],
  },
  "financial-literacy": {
    tagline: "Take control of your money & investments",
    modules: [
      "Personal Budgeting & Saving",
      "Banking, UPI & Digital Payments",
      "Stock Market & Mutual Funds Basics",
      "Income Tax & GST Basics",
      "Insurance & Retirement Planning",
      "Building Your First Investment Portfolio",
    ],
    skills: ["Budgeting", "Investing", "Tax Basics", "Financial Planning", "Excel for Finance"],
    careers: ["Banking Trainee", "Financial Advisor (Jr.)", "Accounts Executive", "Insurance Associate"],
  },
  "tourism": {
    tagline: "Step into India's booming travel & hospitality industry",
    modules: [
      "Indian Tourism: Geography, Heritage & Culture",
      "Travel Planning & Itinerary Design",
      "Online Booking Systems (Amadeus / OTAs)",
      "Hospitality Service Standards",
      "Sustainable & Eco Tourism",
      "Capstone: Plan a 7-day Cultural Tour",
    ],
    skills: ["Itinerary Planning", "Customer Service", "Booking Tools", "Communication"],
    careers: ["Travel Consultant", "Tour Coordinator", "Hospitality Trainee", "Tourism Guide"],
  },
  "agriculture": {
    tagline: "Smart, sustainable & profitable modern farming",
    modules: [
      "Modern Crop Management",
      "Soil Health & Organic Farming",
      "Agri-Tech: IoT, Drones & Apps",
      "Irrigation & Water Management",
      "Agri-Business, Branding & e-NAM",
      "Capstone: Build an Agri Mini Plan",
    ],
    skills: ["Crop Planning", "Soil Testing", "Agri-Tech Tools", "Farm Business", "Sustainability"],
    careers: ["Field Officer", "Agri Entrepreneur", "Krishi Vigyan Trainee", "Agri Sales Executive"],
  },
  "yoga": {
    tagline: "Train your mind & body with classical & modern yoga",
    modules: [
      "Yoga Philosophy & Patanjali Sutras",
      "Asanas: Standing, Sitting, Inversions",
      "Pranayama & Breath Work",
      "Meditation Techniques",
      "Anatomy & Safety in Practice",
      "Designing a Daily Yoga Routine",
    ],
    skills: ["Asana Practice", "Pranayama", "Meditation", "Wellness Coaching"],
    careers: ["Yoga Instructor", "Wellness Coach", "Fitness Trainer", "Retreat Assistant"],
  },
  "content-writing": {
    tagline: "Write words that engage, persuade & rank",
    modules: [
      "Writing Fundamentals & Grammar",
      "Copywriting & Storytelling",
      "SEO Blog Writing",
      "Social Media & Ad Copy",
      "Editing, Proofreading & Style Guides",
      "Building a Writing Portfolio",
    ],
    skills: ["Copywriting", "SEO Writing", "Editing", "Storytelling", "Tone & Voice"],
    careers: ["Content Writer", "Copywriter", "Editor", "Social Media Writer", "Freelancer"],
  },
  "personality-development": {
    tagline: "Build communication, confidence & leadership",
    modules: [
      "Public Speaking & Body Language",
      "Spoken English & Communication",
      "Group Discussion & Interview Prep",
      "Resume, LinkedIn & Personal Branding",
      "Time Management & Productivity",
      "Leadership & Teamwork",
    ],
    skills: ["Public Speaking", "Spoken English", "Interview Skills", "Leadership"],
    careers: ["Soft-skills Trainer", "HR Trainee", "Customer Success Executive", "Trainer Assistant"],
  },
  "governance": {
    tagline: "Understand Indian polity, governance & civic systems",
    modules: [
      "Indian Constitution & Fundamental Rights",
      "Parliament, Judiciary & Federal Structure",
      "Local Self Government (Panchayati Raj)",
      "Public Policy & Welfare Schemes",
      "Election Process & Democratic Institutions",
      "Civic Engagement & RTI",
    ],
    skills: ["Polity Research", "Policy Analysis", "Civic Engagement", "Public Affairs"],
    careers: ["Policy Research Intern", "NGO Coordinator", "Civic-Tech Associate", "UPSC/State PSC Aspirant"],
  },
  "biosciences": {
    tagline: "Life sciences for a sustainable future",
    modules: [
      "Cell Biology & Genetics Basics",
      "Microbiology & Biotechnology",
      "Environmental Science",
      "Public Health & Hygiene",
      "Sustainability & Climate Action",
      "Lab Methods & Field Surveys (overview)",
    ],
    skills: ["Lab Techniques", "Field Surveys", "Scientific Writing", "Sustainability"],
    careers: ["Lab Assistant", "Research Intern", "Environmental Educator", "NGO Associate"],
  },
  "course-related": {
    tagline: "Custom internship aligned to your own degree & subject",
    modules: [
      "Personalized Learning Roadmap",
      "Subject-aligned Research Tasks",
      "Industry-relevant Mini Projects",
      "Domain-specific Assignments",
      "Mentor-led Reviews & Feedback",
      "Capstone Project + Report",
    ],
    skills: ["Domain Knowledge", "Research", "Report Writing", "Project Execution"],
    careers: ["Subject-related Trainee", "Research Assistant", "Domain Intern"],
  },
};
